module.exports = __webpack_public_path__ + "img/5.b4e91dfc.webp";